import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Container, Divider, Link, Typography } from '@mui/material';
import { LoginFirebase } from '../../components/authentication/login';
import Logo from '../../components/Logoblack';
import useAuth from '../../hooks/useAuth';
import gtm from '../../lib/gtm';

function Login() {
  const { platform } = useAuth();

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Ingresar | Fintecsol Factoring</title>
      </Helmet>
      <Box sx={{ backgroundColor: 'background.default', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Container maxWidth="sm" sx={{ py: '80px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 8 }}>
            <RouterLink to="/">
              <Logo sx={{ height: 40, width: 40 }} />
            </RouterLink>
          </Box>
          <Card>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', p: 4 }}>
              <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                <div>
                  <Typography color="textPrimary" gutterBottom variant="h4">
                    Ingresar
                  </Typography>
                  <Typography color="textSecondary" variant="body1">
                    Ingrese a fintecsol factoring
                  </Typography>
                </div>
              </Box>
              <Box sx={{ flexGrow: 1, mt: 3 }}>{platform === 'Firebase' && <LoginFirebase />}</Box>
              <Divider sx={{ my: 3 }} />
              <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <Link
                  color="textSecondary"
                  component={RouterLink}
                  to="/authentication/password-recovery"
                  variant="body1"
                >
                  Restablecer contraseña
                </Link>
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
}

export default Login;
